import UpdateShopCategoryRequestModelBase from '../_generated/modelBases/update-shop-category-request-model-base';

export default class UpdateShopCategoryRequestModel extends UpdateShopCategoryRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
